export function asynchronizeStorage(storage: Storage) {
	return {
		clear: async () => storage.clear(),
		getItem: async (key: string) => storage.getItem(key),
		setItem: async (key: string, value: string) => storage.setItem(key, value),
		removeItem: async (key: string) => storage.removeItem(key),
	};
}
